<template>
  <div class="row justify-content-center text-secondary">
    <div class="col-12">
      <div class="bg-white rounded p-3">



        <div class="row small">
          <div class="col-12 col-md mb-3 mb-md-0"><span class="font-weight-normal">{{__('lang.overview.title')}}</span></div>
          <div class="col-7 col-md"><span class="font-weight-normal">{{__('lang.airflowrate')}}<br>{{__('lang.deviation')}}</span></div>
          <div class="col-5 col-md"><span class="text-right">{{ op.airflow + ' '+ airflowunits_options_selected}}<br>{{airflow_deviation}}</span></div>
          <div class="col-7 col-md"><span class="font-weight-normal text-nowrap">{{__('lang.externalpressure')}} {{pressuretype_options_selected}} <br>{{__('lang.deviation')}}</span></div>
          <div class="col-5 col-md"><span class="text-right">{{ op.pressure + ' '+ pressureunits_options_selected}}<br>{{pressure_deviation}}</span></div>
          <div class="col-7 col-md" v-show="showtypen==true"><span class="font-weight-normal font-weight-normal">{{__('lang.overview.typen')}}</span></div>
          <div class="col-5 col-md" v-show="showtypen==true">
          <!--   <span data-toggle="tooltip" v-b-tooltip.hover :title="selected_categories[0].tooltip">{{ selected_categories[0].name }}<br>{{ selected_categories[0].txt}}</span> -->
            <span>{{ selected_categories[0].name}}<br>{{ selected_categories[0].txt}}</span>
          </div>
         
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import operatingpoint  from './OperatingPoint'
    
    export default {
       /*  props: {
          showopdata: Object, // Define the prop type as Object,
          showselcat: Array,
          showselcatdesc:Array
          
        }, */
        components: {
            operatingpoint,
           
        },
        computed:{
            op: {
              get() {
                return this.$store.state.operatingpoint.op;
              },
              set(value) {
                this.$store.commit('operatingpoint/updateop', value);
              }
            },
            airflow_deviation :function(){
                return parseInt(this.$store.state.operatingpoint.op.airflow_deviation[0]) +' % / '+ parseInt(this.$store.state.operatingpoint.op.airflow_deviation[1])+'%'
                //return parseInt(this.op.airflow_deviation[0]) + ' % / ' + parseInt(this.op.airflow_deviation[1]) + '%'
            },
            pressure_deviation : function(){
                return parseInt(this.$store.state.operatingpoint.op.pressure_deviation[0]) +' % / '+ parseInt(this.$store.state.operatingpoint.op.pressure_deviation[1])+'%'
                //return parseInt(this.op.pressure_deviation[0]) + ' % / ' + parseInt(this.op.pressure_deviation[1]) + '%'
            },
            pressureunits_options_selected:function(){
                    var selected_pressure_unit = this.$store.state.operatingpoint.op.pressureunits
                    var arr = this.$store.state.operatingpoint.op.pressureunits_options.filter(item=>item.value==selected_pressure_unit)
                   /*  var selected_pressure_unit = this.op.pressureunits
                    var arr = this.op.pressureunits_options.filter(item => item.value == selected_pressure_unit) */
                    //return  arr
                    return  this.__(arr[0].text);
            },
            airflowunits_options_selected:function(){
                    var selected_airflow_unit = this.$store.state.operatingpoint.op.airflowunits
                    var arr = this.$store.state.operatingpoint.op.airflowunits_options.filter(item=>item.value==selected_airflow_unit)
                    /* var selected_airflow_unit = this.op.airflowunits
                    var arr = this.op.airflowunits_options.filter(item => item.value ==selected_airflow_unit)
                    */
                    //return  this.__('lang.'+ arr[0].text);
                    return  this.__(arr[0].text);
            },
            pressuretype_options_selected:function(){
                    var selected_pressuretype = this.$store.state.operatingpoint.op.pressuretype
                    var arr = this.$store.state.operatingpoint.op.pressuretype_options.filter(item=>item.value==selected_pressuretype) 
                    /* var selected_pressuretype = this.op.pressuretype
                    var arr = this.op.pressuretype_options.filter(item => item.value == selected_pressuretype) */
                    return arr[0].text;
            },
           
            selected_categories:function(){

              var cat= this.$store.state.operatingpoint.selectedCategories
              //var cat = this.selcat
              var txt=''
              var append_txt=''
              var categories=[]
         
              console.log('selectedcategories cat:')
              console.log(cat)
            

              if (Object.keys(cat).filter(key => cat[key] == true).length == 0) {
                categories.push({
                                name: this.__('lang.overview.all'),
                                txt: ''
                        });  
                
              }
              else if(Object.keys(cat).filter( key => cat[key]==true).length > 1) {
                var cat_count= parseInt(Object.keys(cat).filter( key => cat[key]==true).length - 1)
                    append_txt= '+ ' + cat_count + ' '+this.__('lang.overview.more')
              }
              //var firstItemcat = Object.keys(cat).filter( key => cat[key]==true).shift()



            var selcats=this.$store.state.operatingpoint.descselectedCategories;
            //var selcats = this.selcatdesc
            var tooltip=''
            for (let value of Object.keys(cat).filter( key => cat[key]==true) ){

                  var categorydescription = selcats.filter( k => k.id==value).map(function (categories) { 
                    return categories.desc
                  })
              
               tooltip+= categorydescription + ','
            }

            

              //var selcats=this.$store.state.operatingpoint.descselectedCategories;
              console.log('selected_categories selcats:')
              console.log(selcats)
              var arr = selcats.map(function (categories) { 
                    return categories.desc
              })
              if(arr.length==0) this.showtypen = false

              var firstItemcat = arr.shift()
              //var tooltip=arr.join(',')


              
              categories.push({
                    name: firstItemcat,
                    txt: append_txt,
                    tooltip: tooltip
                  });   
            

                  return categories
            },
        },
        data() {
          return {
            showtypen: true,
             /* op_overview: {

                airflow: '',
                pressure: '',
                airflowunits: 1,
                airflowunits_options: [],
                pressureunits: 5,
                pressureunits_options: [],
                pressuretype: 'stat',
                pressuretype_options: [],
                airflow_deviation: [],
                pressure_deviation: [],
                units: [],
                maxdba: ''
            },
            selcat: [],
            selcatdesc:[] */
          }
        },
        methods: {
           /*  reloadData() {
            // Implement your data reloading logic here
            console.log('i am in opoverview reloaddata');
            }, */

        },
        mounted() {
         /*  console.log('i am in opoverview mounted');
           // Attach event listener to the 'beforeunload' event
            window.addEventListener('beforeunload', this.reloadData); */

           
        },
       /*  beforeDestroy() {
          // Don't forget to remove the event listener when the component is destroyed
          window.removeEventListener('beforeunload', this.reloadData);
        }, */
        watch: {
         /*  showopdata: {
            immediate: true,
            deep: true,
            handler(newVal) {
              console.log('op_overview', newVal)
              this.$nextTick(() => {
                this.op_overview = newVal; // Manually updating the value
                //this.op =  Object.assign({},  newVal);
                 this.$store.commit('operatingpoint/updateop', newVal);
              });
            }
          },
          showselcat: {
              immediate: true,
              deep: true,
              handler(newVal) {
                console.log('showselcat', newVal)
                this.$nextTick(() => {
                  this.selcat = newVal; // Manually updating the value
                  this.$store.commit('operatingpoint/updateSelectedCategories', newVal);
                });
              }
          },
          showselcatdesc: {
              immediate: true,
              deep: true,
              handler(newVal) {
                console.log('showselcatdesc', newVal)
                this.$nextTick(() => {
                  this.selcatdesc = newVal; // Manually updating the value
                  this.$store.commit('operatingpoint/setDescSelectedCategories', newVal);
                });
              }
            } */
        }


    }
 
     
</script>
